import { NgModule } from "@angular/core";

import { 
  NotificationSettingsDialogComponent,
} from "./components/notification-settings-dialog/notification-settings-dialog.component";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatIconModule } from "@angular/material/icon";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatButtonModule } from "@angular/material/button";
import { MatTooltipModule } from "@angular/material/tooltip"; // Add this import
import { ReactiveFormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { MatGridListModule } from "@angular/material/grid-list";
import { MatDividerModule } from "@angular/material/divider";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { DirectivesModule } from "app/shared/directives/directives.module";
import { SmallLayoutComponent } from "./small-layout/small-layout.component";
import { LayoutModule } from "./layout/layout.module";
import { TranslocoModule } from "@ngneat/transloco";


@NgModule({
  imports: [
    DirectivesModule,
    LayoutModule,
    MatToolbarModule,
    MatIconModule,
    MatButtonModule,
    MatSlideToggleModule,
    MatCheckboxModule,
    ReactiveFormsModule,
    MatSlideToggleModule,
    CommonModule,
    MatGridListModule,
    MatDividerModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
    TranslocoModule,
     // Add this to imports array
  ],
  exports: [LayoutModule],
  declarations: [
    NotificationSettingsDialogComponent,

  ],
})
export class AepLayoutModule {}
